/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import moment from 'moment';
import { getType } from 'typesafe-actions';
import { AppAction } from '..';
import { Wmp } from '../../db/stores/wmps';
import { signOutAction } from '../session';
import { getWmps } from './actions';

export type WmpMap = { [facilityid: string]: Wmp };

export interface WmpsState {
  items: WmpMap;
  fetching: boolean;
  lastFetch?: string | null;
  error?: Error;
}

export const wmpsReducer: (state: WmpsState | undefined, action: AppAction) => WmpsState = (
  state: WmpsState = {
    items: {},
    fetching: false,
  },
  action
) => {
  switch (action.type) {
    case getType(getWmps.request):
      return {
        ...state,
        fetching: true,
      };
    case getType(getWmps.success):
      return {
        items: action.payload.reduce((acc: WmpMap, curr: Wmp) => {
          return {
            ...acc,
            [curr.id]: curr,
          };
        }, {}),
        fetching: false,
        lastFetch: moment().toISOString(),
      };
    case getType(signOutAction): {
      return {
        fetching: false,
        items: {},
      };
    }
  }

  return state;
};
